import { XComLogsResponse } from "@/Administration/Api/XComLogs/Dto/XComLogsResponse";
import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";

class XComLogsResponseTableItem implements ITableDataSourceItem<XComLogsResponse> {
    constructor(model: XComLogsResponse) {
        this.Model = model;
    }

    public Model: XComLogsResponse;
    public Name: string;
}

export { XComLogsResponseTableItem };
